$(document).ready(function () {
    const initialElementsCount = 12;
    const additionalElementsOnClick = 4;

    function showMoreCards(number) {
        $(".products_card:hidden").slice(0, number).slideDown();
        if ($(".products_card:hidden").length === 0) {
            $("#loadMore").hide();
        }
    }

    $(".products_card").hide();
    showMoreCards(initialElementsCount);
    $("#loadMore").on("click", function (e) {
        e.preventDefault();

        showMoreCards(additionalElementsOnClick);
    });
});
